import { forwardRef, useColorModeValue } from "@chakra-ui/react"
import { scrollbarStyle } from "theme/scrollbarStyle"

import { MotionBox, MotionBoxProps } from "./Motion"

/**
 * This is a simple card that takes ref, className and style so it can be a child component for react-grid-layout
 * Use this component directly inside the grid component.
 * Eg. ReactResponsiveGrid > AllPoolPosition and PortfolioCard IS this component
 * If you wrap another layer, the resize feature will fail.
 */

export const SimpleCard = forwardRef<MotionBoxProps, "div">(({ style, className, ...props }, ref) => {
    const { children } = props
    const cardBg = useColorModeValue("bottomSheetBg.light", "bottomSheetBg.dark")
    const borderColor = useColorModeValue("blackAlpha.100", "whiteAlpha.100")
    return (
        <MotionBox
            shadow="lg"
            borderColor={borderColor}
            bg={cardBg}
            position="relative"
            boxShadow="sm"
            borderRadius={"2xl"}
            ref={ref}
            sx={scrollbarStyle}
            style={{ ...style }}
            className={className}
            {...props}
        >
            {children}
            {/* the children needs to be kept, so the resize handle from the react-grid-layout can insert the handle element */}
        </MotionBox>
    )
})
